var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.stubPreloaderCart},[_c('div',{class:_vm.$style.cartStubHeader}),_c('StubPreloaderCart'),_c('div',{class:_vm.$style.cartStubFooter})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }